<template>
	<footer>
		<div class="container">
			<div v-for="(column, index) in footer" :key="index" class="content" :class="'footer-' + index">
				<h2>{{ column.title }}</h2>
				<ul>
					<template v-for="(link, linkIndex) in column.links">
						<template v-if="link.url == null">
							<li v-html="link.title" :key="linkIndex"></li>
						</template>

						<Link
							v-else
							:title="link.title"
							:url="link.url"
							:target="link.target"
							:image="link.image"
							:alt="link.alt"
							:className="index"
							:key="linkIndex"
						/>
					</template>
				</ul>
			</div>
		</div>

		<div class="copyright" v-html="$t('Foot.copyright')"></div>
	</footer>
</template>
<script>
import Link from '../partials/Link.vue'
export default {
	name: 'Foot',
	components: { Link },
	computed: {
		footer() {
			return this.$t('Foot.links')
		},
	},
}
</script>

<style scoped lang="scss">
footer {
	background-color: $blueTheme;
	color: $white;
	padding: 0px;
}

.container {
	@include flex-container(space-between, flex-start, flex-start, nowrap);
	margin: 0 auto;
}

.content {
	padding: 32px 0;
	flex-basis: 25%;

	h2 {
		@extend %opensans;
		padding-bottom: 22px;
		font-weight: 600;
		font-size: 24px;
		text-align: left;
		letter-spacing: 1px;
	}

	li {
		@extend %opensans;
		padding: 8px 0;
		font-size: 18px;
	}
}

.footer-contact {
	h2 {
		padding-bottom: 22px;
	}

	ul {
		li {
			padding: 0;
			font-size: 16px;
			line-height: 1.5;
			margin-bottom: 5px;

			&:nth-child(1) {
				margin-bottom: 24px;
			}
		}
	}
}

.footer-social {
	ul {
		@include flex-container(space-between);
		margin: 0 auto;
	}

	h2 {
		text-align: center;
		padding-bottom: 63px;
	}

	img {
		height: 25px;
		width: auto;
	}
}

.copyright {
	text-align: center;
	padding: 10px;
}

@include mobile {
	.container {
		display: block;
		text-align: center;
	}

	.content {
		width: 100%;
		padding: 32px 0 0;

		h2 {
			text-align: center;
		}
	}

	.footer-social {
		ul {
			max-width: 60%;
		}

		h2 {
			padding-bottom: 15px;
		}
	}
}
</style>
